import { render, staticRenderFns } from "./MemberAddressTypeSelect.vue?vue&type=template&id=5d0de858&"
import script from "./MemberAddressTypeSelect.vue?vue&type=script&lang=js&"
export * from "./MemberAddressTypeSelect.vue?vue&type=script&lang=js&"
import style0 from "./MemberAddressTypeSelect.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports